import toastr from 'toastr';

function onCopySuccess() {
  toastr.success('Copied to clipboard');
}

function onCopyFailure() {
  toastr.error('Could not copy to clipboard');
}

function copyToClipboardFallback(textToCopy) {
  const textAreaDom = document.createElement('textarea');

  textAreaDom.value = textToCopy;

  document.body.appendChild(textAreaDom);

  textAreaDom.focus();
  textAreaDom.select();

  let success = true;
  try {
    success = document.execCommand('copy');
  } catch (_) {
    success = false;
  }

  document.body.removeChild(textAreaDom);

  if (success) onCopySuccess();
  else onCopyFailure();
}

export default function copyToClipboard(textToCopy) {
  if (!navigator.clipboard) {
    copyToClipboardFallback(textToCopy);
    return;
  }

  navigator.clipboard
    .writeText(textToCopy)
    .then(
      () => onCopySuccess(),
      () => copyToClipboardFallback(textToCopy),
    );
}
